export default __webpack_public_path__ + "static/ecofriendly-luxury-tent-12cb92e141f90743806183b485ff2f42.jpg";